import { Select, ISelect } from ".";
import { textChooser } from "../../../util/textChooser";
import { documentValues } from "../../../util/GlobalData";

interface DocumentsProps extends ISelect {
  defaultValue?: string | number
}

export const Documents = (props: DocumentsProps) => {
  return (
    <Select
      currentValue={props?.currentValue}
      values={documentValues}
      subLabel={textChooser("txt73")}
      hook={props?.hook}
      defaultValue={props.defaultValue}
    />
  )
}